/**
 * Curated whitelist of lucide-react icons available for use in the Features CMS.
 *
 * The admin CMS uses the KEYS of this map to render a dropdown; the public
 * /features page and detail pages use this same map (with a Sparkles fallback)
 * to resolve icon strings coming from the DB into actual React components.
 */
import {
  // Sales & CRM
  Presentation, Search, FileText, Users, UserPlus, Briefcase,
  MessageSquare, MessageCircle, Mail, FolderKanban,
  // Orders & Production
  ClipboardList, Globe, Calendar, Activity, PenTool, FileSignature,
  Truck, Plug,
  // Inventory & Procurement
  Boxes, PackageCheck, ShoppingCart, ShieldCheck, Wallet, Files,
  // Finance
  Receipt, CreditCard, Coins, FileBarChart, Gift,
  // Reporting / Automation / AI
  LayoutDashboard, Target, BarChart3, Brain, Sparkles, Zap, ClockArrowUp,
  // Extras admins might want when adding new features
  Rocket, Star, Cloud, Database, Lock, Server, Cpu, Layers, Store, Package,
  Palette, Camera, Video, Mic, Phone, Building2, MapPin, Bell,
  BookOpen, GraduationCap, LineChart, PieChart, ThumbsUp, Heart,
  CheckCircle2, Award, Trophy, Flame, Filter, Settings,
  RefreshCw, Send, Share2, Tag, Wrench,
} from "lucide-react";

// Ordered so the admin dropdown groups related icons visually.
export const FEATURE_ICONS = {
  Presentation, Search, FileText, Users, UserPlus, Briefcase,
  MessageSquare, MessageCircle, Mail, FolderKanban,
  ClipboardList, Globe, Calendar, Activity, PenTool, FileSignature, Truck, Plug,
  Boxes, PackageCheck, ShoppingCart, ShieldCheck, Wallet, Files,
  Receipt, CreditCard, Coins, FileBarChart, Gift,
  LayoutDashboard, Target, BarChart3, Brain, Sparkles, Zap, ClockArrowUp,
  Rocket, Star, Cloud, Database, Lock, Server, Cpu, Layers, Store, Package,
  Palette, Camera, Video, Mic, Phone, Building2, MapPin, Bell,
  BookOpen, GraduationCap, LineChart, PieChart, ThumbsUp, Heart,
  CheckCircle2, Award, Trophy, Flame, Filter, Settings,
  RefreshCw, Send, Share2, Tag, Wrench,
};

export const FEATURE_ICON_NAMES = Object.keys(FEATURE_ICONS);

/** Resolve a string name → lucide icon component. Falls back to Sparkles. */
export function getFeatureIcon(name) {
  if (name && FEATURE_ICONS[name]) return FEATURE_ICONS[name];
  return Sparkles;
}
